var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { LineChart, PieChart, BarChart, TrendingUp, Award, Users, DollarSign, ArrowUpRight, MapPin } from 'lucide-react';
import api from '../actions/api';
import { Line, Bar, Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend, Filler } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend, Filler);
var defaults = {
    totalManaged: 3542879,
    managedGrowth: 18.7,
    impressions: 28753412,
    impressionsGrowth: 32,
    conversions: 146728,
    conversionsGrowth: 12.3,
    clientCount: 42,
    newClientsThisMonth: 3,
    averageROI: 347,
    roiGrowthVsBenchmark: 5.2,
    geoStates: 13
};
var fmtNumber = function (n) { return n.toLocaleString('pt-BR'); };
var fmtMoney = function (n) { return "R$ ".concat(n.toLocaleString('pt-BR')); };
var AgencyDashboard = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var _m = useState(null), agencyData = _m[0], setAgencyData = _m[1];
    var _o = useState('month'), timeRange = _o[0], setTimeRange = _o[1]; // 'week' | 'month' | 'quarter' | 'year'
    var _p = useState(true), isLoading = _p[0], setIsLoading = _p[1];
    var _q = useState(false), presentationMode = _q[0], setPresentationMode = _q[1];
    useEffect(function () {
        var fetchAgencyStats = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setIsLoading(true);
                        return [4 /*yield*/, api.get("/agency/stats?timeRange=".concat(timeRange))];
                    case 1:
                        data = (_a.sent()).data;
                        setAgencyData(data);
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        // mantém defaults como fallback visual
                        console.error('Erro ao carregar dados da agência:', e_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchAgencyStats();
    }, [timeRange]);
    var stats = {
        totalManaged: (_a = agencyData === null || agencyData === void 0 ? void 0 : agencyData.totalManaged) !== null && _a !== void 0 ? _a : defaults.totalManaged,
        managedGrowth: (_b = agencyData === null || agencyData === void 0 ? void 0 : agencyData.managedGrowth) !== null && _b !== void 0 ? _b : defaults.managedGrowth,
        impressions: (_c = agencyData === null || agencyData === void 0 ? void 0 : agencyData.impressions) !== null && _c !== void 0 ? _c : defaults.impressions,
        impressionsGrowth: (_d = agencyData === null || agencyData === void 0 ? void 0 : agencyData.impressionsGrowth) !== null && _d !== void 0 ? _d : defaults.impressionsGrowth,
        conversions: (_e = agencyData === null || agencyData === void 0 ? void 0 : agencyData.conversions) !== null && _e !== void 0 ? _e : defaults.conversions,
        conversionsGrowth: (_f = agencyData === null || agencyData === void 0 ? void 0 : agencyData.conversionsGrowth) !== null && _f !== void 0 ? _f : defaults.conversionsGrowth,
        clientCount: (_g = agencyData === null || agencyData === void 0 ? void 0 : agencyData.clientCount) !== null && _g !== void 0 ? _g : defaults.clientCount,
        newClientsThisMonth: (_h = agencyData === null || agencyData === void 0 ? void 0 : agencyData.newClientsThisMonth) !== null && _h !== void 0 ? _h : defaults.newClientsThisMonth,
        averageROI: (_j = agencyData === null || agencyData === void 0 ? void 0 : agencyData.averageROI) !== null && _j !== void 0 ? _j : defaults.averageROI,
        roiGrowthVsBenchmark: (_k = agencyData === null || agencyData === void 0 ? void 0 : agencyData.roiGrowthVsBenchmark) !== null && _k !== void 0 ? _k : defaults.roiGrowthVsBenchmark,
        geoStates: (_l = agencyData === null || agencyData === void 0 ? void 0 : agencyData.geoStates) !== null && _l !== void 0 ? _l : defaults.geoStates
    };
    var brandGradientText = "bg-gradient-to-r from-cyan-300 via-fuchsia-300 to-pink-300 bg-clip-text text-transparent";
    // Mock de séries (últimos 12 meses)
    var labels = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    var managedSeries = [180, 210, 240, 260, 290, 310, 320, 340, 360, 380, 410, 440]; // em milhares
    var conversionsSeries = [8200, 9100, 10200, 9800, 11300, 12000, 12500, 13200, 14100, 15000, 15800, 16528];
    var platformSplit = [
        { label: 'Meta Ads', value: 48, color: '#22d3ee' },
        { label: 'Google Ads', value: 36, color: '#a78bfa' },
        { label: 'TikTok Ads', value: 10, color: '#ec4899' },
        { label: 'LinkedIn Ads', value: 6, color: '#f59e0b' },
    ];
    var roiByChannel = [
        { label: 'Meta', value: 312 },
        { label: 'Google', value: 368 },
        { label: 'TikTok', value: 284 },
        { label: 'LinkedIn', value: 221 },
    ];
    // Mock do funil (valores decrescentes)
    var funnelData = [
        { label: 'Impressões', value: 28753412, color: '#22d3ee' },
        { label: 'Cliques', value: 1723500, color: '#a78bfa' },
        { label: 'Leads', value: 146728, color: '#ec4899' },
        { label: 'Oportunidades', value: 42800, color: '#f59e0b' },
        { label: 'Vendas', value: 8200, color: '#10b981' },
    ];
    // Helpers de gradiente
    var getGradient = function (ctx, area, from, to) {
        var gradient = ctx.createLinearGradient(0, area.bottom, 0, area.top);
        gradient.addColorStop(0, from);
        gradient.addColorStop(1, to);
        return gradient;
    };
    return (React.createElement("div", { className: "min-h-screen p-8 ".concat(presentationMode ? 'bg-gray-950 text-white' : 'bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 text-gray-100') },
        React.createElement("div", { className: "flex flex-col gap-2 md:flex-row md:items-center md:justify-between mb-8" },
            React.createElement("div", null,
                React.createElement("div", { className: "text-xs tracking-[0.35em] uppercase ".concat(brandGradientText) }, "Vision Cockpit"),
                React.createElement("h1", { className: "text-2xl md:text-3xl font-bold" }, "Resultados da Ag\u00EAncia"),
                React.createElement("p", { className: "text-sm text-gray-400" },
                    "Gerenciamos ",
                    fmtMoney(stats.totalManaged),
                    " dos nossos clientes ",
                    timeRange === 'month' ? 'neste mês' : 'no período selecionado',
                    ".")),
            React.createElement("div", { className: "flex gap-3 items-center" },
                React.createElement("select", { value: timeRange, onChange: function (e) { return setTimeRange(e.target.value); }, className: "bg-gray-900/60 border border-white/10 rounded px-3 py-2 text-sm" },
                    React.createElement("option", { value: "week" }, "\u00DAltimos 7 dias"),
                    React.createElement("option", { value: "month" }, "Este m\u00EAs"),
                    React.createElement("option", { value: "quarter" }, "Este trimestre"),
                    React.createElement("option", { value: "year" }, "Este ano")),
                React.createElement("button", { onClick: function () { return setPresentationMode(!presentationMode); }, className: "px-4 py-2 rounded bg-gradient-to-r from-cyan-600 via-fuchsia-600 to-pink-600 hover:from-cyan-500 hover:via-fuchsia-500 hover:to-pink-500 transition text-white" }, presentationMode ? 'Sair da Apresentação' : 'Modo Apresentação'))),
        React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-8" },
            React.createElement(MetricCard, { title: "Total sob Gest\u00E3o", value: fmtMoney(stats.totalManaged), change: stats.managedGrowth, changeLabel: "vs per\u00EDodo anterior", icon: React.createElement(DollarSign, { className: "w-5 h-5" }) }),
            React.createElement(MetricCard, { title: "Impress\u00F5es Totais", value: fmtNumber(stats.impressions), change: stats.impressionsGrowth, changeLabel: "vs per\u00EDodo anterior", icon: React.createElement(BarChart, { className: "w-5 h-5" }) }),
            React.createElement(MetricCard, { title: "Convers\u00F5es Geradas", value: fmtNumber(stats.conversions), change: stats.conversionsGrowth, changeLabel: "vs per\u00EDodo anterior", icon: React.createElement(Award, { className: "w-5 h-5" }) }),
            React.createElement(MetricCard, { title: "Clientes Ativos", value: "".concat(fmtNumber(stats.clientCount), " "), note: "(".concat(fmtNumber(stats.newClientsThisMonth), " novos este m\u00EAs)"), icon: React.createElement(Users, { className: "w-5 h-5" }) }),
            React.createElement(MetricCard, { title: "ROI M\u00E9dio das Campanhas", value: "".concat(stats.averageROI, "%"), change: stats.roiGrowthVsBenchmark, changeLabel: "vs benchmark do setor", icon: React.createElement(TrendingUp, { className: "w-5 h-5" }) }),
            React.createElement(MetricCard, { title: "Presen\u00E7a Geogr\u00E1fica", value: "Atua\u00E7\u00E3o em ".concat(fmtNumber(stats.geoStates), " estados"), icon: React.createElement(MapPin, { className: "w-5 h-5" }) })),
        React.createElement("div", { className: "grid grid-cols-1 xl:grid-cols-3 gap-6" },
            React.createElement(ChartCard, { title: "Evolu\u00E7\u00E3o do Total sob Gest\u00E3o", icon: React.createElement(LineChart, { className: "w-4 h-4" }) },
                React.createElement(Line, { data: {
                        labels: labels,
                        datasets: [{
                                label: 'R$ (mil)',
                                data: managedSeries,
                                fill: true,
                                borderWidth: 2,
                                borderColor: function (ctx) {
                                    var chart = ctx.chart;
                                    var c = chart.ctx, chartArea = chart.chartArea;
                                    if (!chartArea)
                                        return '#22d3ee';
                                    return getGradient(c, chartArea, '#22d3ee', '#ec4899');
                                },
                                backgroundColor: function (ctx) {
                                    var chart = ctx.chart;
                                    var c = chart.ctx, chartArea = chart.chartArea;
                                    if (!chartArea)
                                        return 'rgba(34,211,238,0.15)';
                                    return getGradient(c, chartArea, 'rgba(34,211,238,0.12)', 'rgba(236,72,153,0.08)');
                                },
                                tension: 0.35,
                                pointRadius: 0,
                            }]
                    }, options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: { display: false },
                            tooltip: { mode: 'index', intersect: false },
                        },
                        scales: {
                            x: {
                                grid: { color: 'rgba(255,255,255,0.06)' },
                                ticks: { color: '#9ca3af' }
                            },
                            y: {
                                grid: { color: 'rgba(255,255,255,0.06)' },
                                ticks: { color: '#9ca3af' }
                            }
                        }
                    }, height: 260 })),
            React.createElement(ChartCard, { title: "Distribui\u00E7\u00E3o por Plataforma", icon: React.createElement(PieChart, { className: "w-4 h-4" }) },
                React.createElement(Doughnut, { data: {
                        labels: platformSplit.map(function (p) { return p.label; }),
                        datasets: [{
                                data: platformSplit.map(function (p) { return p.value; }),
                                backgroundColor: platformSplit.map(function (p) { return p.color; }),
                                borderWidth: 0,
                                hoverOffset: 6
                            }]
                    }, options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                position: 'bottom',
                                labels: { color: '#e5e7eb', boxWidth: 12, usePointStyle: true }
                            },
                            tooltip: { callbacks: { label: function (ctx) { return "".concat(ctx.label, ": ").concat(ctx.parsed, "%"); } } }
                        },
                        cutout: '62%'
                    }, height: 260 })),
            React.createElement(ChartCard, { title: "Convers\u00F5es por m\u00EAs", icon: React.createElement(BarChart, { className: "w-4 h-4" }) },
                React.createElement(Bar, { data: {
                        labels: labels,
                        datasets: [{
                                label: 'Conversões',
                                data: conversionsSeries,
                                borderRadius: 8,
                                backgroundColor: 'rgba(167,139,250,0.35)',
                                borderColor: '#a78bfa',
                                borderWidth: 1
                            }]
                    }, options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: { display: false },
                            tooltip: { mode: 'index', intersect: false }
                        },
                        scales: {
                            x: {
                                grid: { display: false },
                                ticks: { color: '#9ca3af' }
                            },
                            y: {
                                grid: { color: 'rgba(255,255,255,0.06)' },
                                ticks: { color: '#9ca3af' }
                            }
                        }
                    }, height: 260 }))),
        React.createElement("div", { className: "grid grid-cols-1 gap-6 mt-6" },
            React.createElement(ChartCard, { title: "ROI por Canal", icon: React.createElement(TrendingUp, { className: "w-4 h-4" }) },
                React.createElement(Bar, { data: {
                        labels: roiByChannel.map(function (r) { return r.label; }),
                        datasets: [{
                                label: 'ROI (%)',
                                data: roiByChannel.map(function (r) { return r.value; }),
                                borderRadius: 8,
                                backgroundColor: 'rgba(34,211,238,0.35)',
                                borderColor: '#22d3ee',
                                borderWidth: 1
                            }]
                    }, options: {
                        indexAxis: 'y',
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: { display: false },
                            tooltip: { callbacks: { label: function (ctx) { return "".concat(ctx.parsed.x, "%"); } } }
                        },
                        scales: {
                            x: {
                                grid: { color: 'rgba(255,255,255,0.06)' },
                                ticks: { color: '#9ca3af' }
                            },
                            y: {
                                grid: { display: false },
                                ticks: { color: '#e5e7eb' }
                            }
                        }
                    }, height: 220 }))),
        React.createElement("div", { className: "grid grid-cols-1 gap-6 mt-6" },
            React.createElement(ChartCard, { title: "Funil de Marketing", icon: React.createElement(TrendingUp, { className: "w-4 h-4" }), className: "h-auto" },
                React.createElement(FunnelChart, { data: funnelData }))),
        isLoading && (React.createElement("div", { className: "mt-8 text-center text-sm text-gray-400" }, "Carregando dados..."))));
};
var MetricCard = function (_a) {
    var title = _a.title, value = _a.value, icon = _a.icon, change = _a.change, changeLabel = _a.changeLabel, note = _a.note;
    var positive = (change !== null && change !== void 0 ? change : 0) >= 0;
    return (React.createElement("div", { className: "relative rounded-xl p-5 bg-gray-900/60 border border-white/10 shadow-md" },
        React.createElement("div", { className: "absolute -top-10 -right-10 h-24 w-24 rounded-full bg-fuchsia-500/5 blur-2xl" }),
        React.createElement("div", { className: "flex items-start justify-between relative" },
            React.createElement("div", null,
                React.createElement("div", { className: "text-xs text-gray-400" }, title),
                React.createElement("div", { className: "text-xl font-semibold" },
                    value,
                    " ",
                    note && React.createElement("span", { className: "text-gray-400 text-sm" }, note))),
            React.createElement("div", { className: "p-2 rounded-md bg-gradient-to-r from-cyan-500/15 via-fuchsia-500/15 to-pink-500/15 text-cyan-300" }, icon)),
        typeof change === 'number' && (React.createElement("div", { className: "mt-3 inline-flex items-center text-sm ".concat(positive ? 'text-emerald-400' : 'text-rose-400') },
            React.createElement(ArrowUpRight, { size: 16, className: !positive ? 'rotate-180' : '' }),
            React.createElement("span", { className: "ml-1 font-semibold" },
                Math.abs(change).toLocaleString('pt-BR', { maximumFractionDigits: 1 }),
                "%"),
            changeLabel && React.createElement("span", { className: "ml-2 text-gray-400" }, changeLabel)))));
};
var FunnelChart = function (_a) {
    var data = _a.data;
    if (!(data === null || data === void 0 ? void 0 : data.length))
        return null;
    // Suavização para estética (evita quedas bruscas)
    var base = data[0].value || 1;
    var minAbsPct = 18; // largura mínima de cada etapa em relação ao container pai (%)
    var pow = 0.6; // 0.5–0.7 suaviza
    var sliceH = 64; // altura de cada etapa
    var capH = 12; // altura do “cap” elíptico
    // Largura absoluta de cada etapa, em % do container pai
    var widthAbs = function (v) { return Math.max(Math.pow(v / base, pow) * 100, minAbsPct); };
    var widths = data.map(function (d) { return widthAbs(d.value); });
    return (React.createElement("div", { className: "py-3" },
        data.map(function (step, idx) {
            var _a;
            var curr = widths[idx]; // largura atual (em % do pai)
            var next = (_a = widths[idx + 1]) !== null && _a !== void 0 ? _a : Math.max(curr * 0.75, minAbsPct); // próxima largura (em % do pai)
            // Importante: o clip-path é relativo ao próprio slice (100% = largura do slice).
            // topo = 100%, base = next/curr (%) do próprio slice
            var bottomRatio = Math.min(100, Math.max((next / curr) * 100, (minAbsPct / curr) * 100));
            var leftBottom = (100 - bottomRatio) / 2;
            var rightBottom = 100 - leftBottom;
            var polygon = "polygon(0% 0%, 100% 0%, ".concat(rightBottom, "% 100%, ").concat(leftBottom, "% 100%)");
            var conv = idx > 0 ? (step.value / data[idx - 1].value) * 100 : 100;
            return (React.createElement("div", { key: idx, className: "relative mx-auto my-3", style: { width: "".concat(curr, "%"), height: sliceH, animation: "funnelEnter 480ms ease ".concat(idx * 60, "ms both") } },
                React.createElement("div", { className: "mx-auto", style: {
                        height: capH,
                        width: '100%',
                        borderRadius: "".concat(capH, "px / ").concat(capH / 1.4, "px"),
                        background: "linear-gradient(180deg, ".concat(step.color, "aa, ").concat(step.color, "66)"),
                        border: "1px solid ".concat(step.color, "80"),
                        boxShadow: "0 10px 28px ".concat(step.color, "22"),
                    } }),
                React.createElement("div", { className: "relative", style: {
                        height: sliceH - capH,
                        marginTop: -2,
                        clipPath: polygon,
                        background: "linear-gradient(90deg, ".concat(step.color, "30, ").concat(step.color, "55)"),
                        borderLeft: "1px solid ".concat(step.color, "66"),
                        borderRight: "1px solid ".concat(step.color, "66"),
                        boxShadow: "0 12px 30px ".concat(step.color, "26"),
                    } },
                    React.createElement("div", { className: "absolute inset-0 pointer-events-none", style: {
                            background: 'linear-gradient(180deg, rgba(255,255,255,0.06), transparent 55%), radial-gradient(120% 60% at 50% -20%, rgba(255,255,255,0.10), transparent 60%)',
                            mixBlendMode: 'screen',
                        } })),
                React.createElement("div", { className: "absolute left-1/2 -bottom-[6px] -translate-x-1/2", style: {
                        height: capH - 4,
                        width: "".concat(bottomRatio, "%"),
                        borderRadius: "".concat(capH, "px / ").concat(capH / 1.6, "px"),
                        background: "linear-gradient(180deg, ".concat(step.color, "66, ").concat(step.color, "44)"),
                        border: "1px solid ".concat(step.color, "66"),
                        boxShadow: "0 8px 18px ".concat(step.color, "22"),
                    } }),
                React.createElement("div", { className: "absolute inset-0 flex items-center justify-end pr-3 text-sm" },
                    React.createElement("div", { className: "flex items-center gap-3" },
                        idx > 0 && (React.createElement("span", { className: "text-xs px-2 py-0.5 rounded-full bg-gray-900/70 border border-white/10 text-gray-200" },
                            conv.toLocaleString('pt-BR', { maximumFractionDigits: 1 }),
                            "% conv.")),
                        React.createElement("span", { className: "text-gray-100 font-semibold" }, step.value.toLocaleString('pt-BR'))))));
        }),
        React.createElement("style", null, "\n          @keyframes funnelEnter {\n            from { opacity: 0; transform: translateY(8px) scaleX(0.98); }\n            to   { opacity: 1; transform: translateY(0)     scaleX(1); }\n          }\n        ")));
};
var ChartCard = function (_a) {
    var title = _a.title, icon = _a.icon, children = _a.children, _b = _a.className, className = _b === void 0 ? 'h-80' : _b;
    return (React.createElement("div", { className: "relative rounded-xl p-5 bg-gray-900/50 border border-white/10 shadow-xl ".concat(className) },
        React.createElement("div", { className: "absolute -top-10 -right-10 h-24 w-24 rounded-full bg-pink-500/5 blur-2xl" }),
        React.createElement("div", { className: "mb-3 flex items-center gap-2 text-sm text-gray-300" },
            icon,
            React.createElement("span", null, title)),
        React.createElement("div", { className: "h-[calc(100%-2rem)]" }, children)));
};
export default AgencyDashboard;
